const pad = (value) => String(value).padStart(2, "0");

export const formatDateInputValue = (date) => {
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  return `${year}-${month}-${day}`;
};

export const getPresetDateRange = (preset, now = new Date()) => {
  const end = new Date(now);
  const start = new Date(now);

  if (preset === "today") {
    return {
      from: formatDateInputValue(start),
      to: formatDateInputValue(end),
    };
  }

  if (preset === "last7") {
    start.setDate(start.getDate() - 6);
  } else if (preset === "last30") {
    start.setDate(start.getDate() - 29);
  } else if (preset === "month") {
    start.setDate(1);
  }

  return {
    from: formatDateInputValue(start),
    to: formatDateInputValue(end),
  };
};

export const getDefaultReportingFilters = () => ({
  storeIds: [],
  from: getPresetDateRange("today").from,
  to: getPresetDateRange("today").to,
});

export const getUtcRangeFromDateInputs = ({ from, to }) => {
  const fromValue = from ? new Date(`${from}T00:00:00`).toISOString() : null;
  const toValue = to ? new Date(`${to}T23:59:59.999`).toISOString() : null;

  return {
    from: fromValue,
    to: toValue,
  };
};

export const formatCurrency = (amount, currencyCode = "USD") => {
  const value = Number(amount || 0);
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode || "USD",
      maximumFractionDigits: 2,
    }).format(value);
  } catch (error) {
    return `${currencyCode || "USD"} ${value.toFixed(2)}`;
  }
};

export const formatNumber = (value) =>
  new Intl.NumberFormat("en-US").format(Number(value || 0));

export const formatDateTime = (value) => {
  if (!value) {
    return "-";
  }

  try {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    }).format(new Date(value));
  } catch (error) {
    return value;
  }
};

export const formatPercent = (value) => `${Number(value || 0).toFixed(1)}%`;

export const getStoreOptionsFromBusinesses = (businesses) => {
  if (!Array.isArray(businesses)) {
    return [];
  }

  return businesses.flatMap((business) =>
    Array.isArray(business.stores)
      ? business.stores.map((store) => ({
          id: store.storeId || store.id,
          name: store.storeName || store.name,
          businessName: business.businessName || business.name,
        }))
      : [],
  );
};

export const getUniqueCurrencyCode = (
  ordersOrStores = [],
  fallback = "USD",
) => {
  const codes = [
    ...new Set(
      ordersOrStores.map((entry) => entry?.currencyCode).filter(Boolean),
    ),
  ];
  return codes.length === 1 ? codes[0] : fallback;
};
